import { render, staticRenderFns } from "./DocumentPOSList.vue?vue&type=template&id=1580eb6f"
import script from "./DocumentPOSList.vue?vue&type=script&lang=js"
export * from "./DocumentPOSList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports